import { Event } from '@/model/event';
import { Customer } from '@/model/customer';
import { Entity } from '@/model/entity';
import { Invoice } from '@/model/invoice';

export enum BookingStatus {
  OPEN = 'OPEN',
  CANCELED = 'CANCELED',
  NO_SHOW = 'NO_SHOW',
  EXECUTED = 'EXECUTED',
}

export interface Booking extends Entity {
  comment?: string;
  private_comment?: string;
  status?: BookingStatus;
  no_show?: boolean;
  customer_id: number;
  created_by?: number;
  modified_by?: number;
  total?: number;

  start?: string;
  end?: string;
  customer_start?: string;
  customer_end?: string;

  events: Event[];
  invoice?: Invoice;
  customer?: Customer;
}
